import { Bonus, createBlockBonusMutation } from 'shared/api';
import { ConfirmModalModel, createConfirmModalModel, declareModalData } from 'shared/lib';

export type BlockBonusModel = ConfirmModalModel<Bonus, number, Bonus>;

export const createBlockBonusModel = (): BlockBonusModel => {
	const blockBonusMutation = createBlockBonusMutation();

	const model = createConfirmModalModel<Bonus, number, Bonus>({
		modalData: declareModalData<Bonus>(),
		mapModalData: ({ id }) => id,
		mutation: blockBonusMutation,
		successMessageKey: 'block-bonus.success',
	});

	return model;
};
